// SelectionMetadata.tsx
import React from 'react';
import { ServiceSelection } from '../../../types/planningTypes';

interface SelectionMetadataProps {
  selection: ServiceSelection;
}

export const SelectionMetadata: React.FC<SelectionMetadataProps> = ({ selection }) => {
  if (!selection.composer_name && !selection.lyricist_name && !selection.version_title) {
    return null;
  }

  return (
    <div className="ps-0">
      {(selection.composer_name || selection.lyricist_name) && (
        <div className="text-muted small">
          {selection.composer_name && `Composer: ${selection.composer_name}`}
          {selection.composer_name && selection.lyricist_name && ' • '}
          {selection.lyricist_name && `Lyricist: ${selection.lyricist_name}`}
        </div>
      )}
      {selection.version_title && (
        <div className="text-muted small fst-italic">
          Version: {selection.version_title}
        </div>
      )}
    </div>
  );
};